import { ChevronDown, ChevronUp } from "lucide-react";
import { LivePreviewPanelProps } from "./types";
import { PhoneMockup } from "../phone-mock";

export const LivePreviewPanel: React.FC<LivePreviewPanelProps> = ({
  isExpanded,
  onToggle,
  senderName,
  messageText,
  audienceCount = 500,
  totalAudience = 4348,
  smsParts = 1,
  costPerMessage = 1,
  totalCost = 1000,
}) => {
  const audiencePercent = Math.round((audienceCount / totalAudience) * 100);

  return (
    <div className="bg-white border-l border-gray-200 h-full flex flex-col">
      <div className="p-4 border-b border-gray-100">
        <h2 className="font-semibold text-gray-900 text-base">Live Preview</h2>
      </div>

      {/* Estimated Reach */}
      <div className="p-4 border-b border-gray-100">
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-between"
        >
          <div className="flex items-center gap-2">
            <span className="font-medium text-gray-900 text-sm">Your Estimated Reach</span>
            <span className="w-3 h-3 bg-green-500 rounded-full block" />
          </div>
          {isExpanded ? (
            <ChevronUp className="w-4 h-4 text-gray-400" />
          ) : (
            <ChevronDown className="w-4 h-4 text-gray-400" />
          )}
        </button>

        {isExpanded && (
          <div className="mt-3 space-y-3">
            <div>
              <p className="text-xs text-gray-500 mb-1">Audience Selected</p>
              <p className="text-sm font-semibold text-indigo-600">
                {audienceCount.toLocaleString()} of {totalAudience.toLocaleString()} contacts
              </p>
              <div className="mt-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-indigo-500 rounded-full transition-all"
                  style={{ width: `${audiencePercent}%` }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-gray-500">SMS Parts</p>
                <p className="text-sm font-semibold text-gray-900">{smsParts}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Cost per message</p>
                <p className="text-sm font-semibold text-gray-900">$ {costPerMessage}</p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-3">
              <p className="text-xs text-gray-500">Total cost</p>
              <p className="text-lg font-bold text-gray-900">$ {totalCost.toLocaleString()}</p>
            </div>
          </div>
        )}
      </div>

      {/* Phone Preview */}
      <div className="flex-1 p-4 overflow-y-auto">
        <PhoneMockup message={messageText} senderName={senderName} />
      </div>
    </div>
  );
};
